export default () => ({
  notificationTable: { width: '100%' },
  tableHeaderCell: {
    textAlign: 'center',
    padding: 0,
    '&:last-child': { padding: 0 },
  },
  checkboxCell: {
    textAlign: 'center',
    width: '60px',
    '&:last-child': { padding: '.5em 1em' },
  },
  cardHeaderIcons: { float: 'right' },
  notificationsContainer: {
    width: '100%',
    overflowX: 'auto',
  },
});
